export default __webpack_public_path__ + "3fce620b483a0549376f27b0a4037f39.png";